import { ParamsReportEpsEmployee } from './../model/params-report-eps-employee';
import { Injectable, Injector } from '@angular/core';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { Vars } from '../model/vars';
import { Observable } from 'rxjs/Observable';
import { map , tap} from 'rxjs/operators';
import { catchError  } from 'rxjs/operators';
import { ReportEpsEmployee } from './../model/report-eps-employee';

@Injectable()
export class ReportEpsEmployeeService extends BaseReportService<ReportEpsEmployee> {

  public uri = '/api/reportEpsEmployee/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance ReportDeductionsByEmployeeType');
  }

  buildSentence(entity?: ReportEpsEmployee, event?: LazyLoadEvent): HttpParams {
    return null;
  }

  searchToViewTable(   params : ParamsReportEpsEmployee
    ): Observable<any> { 
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`;
        return this.httpClient.post<any>(url, params )
        .pipe(
          tap(response => { 
            return response;
          },
           error =>{ 
             this.spinnerService.hideAll();
           },
           ()=>{ 
            this.spinnerService.hideAll();
           }
          ), 
          catchError((err) => {
              //let resp = "No se encontraron registros";  
              this.spinnerService.hideAll();
              //console.log(err);
              this.notificationService.serverErrorMessage(err);
              //if(err.status==404)
              //this.notificationService.smallBoxWarning("Ventana de Alerta!",resp);  
              return new Observable<Blob>();
          })
       );
  } 
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-eps-employee.service.ts